import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

type ShadowBoxingResponse = {
  shadowBoxing: ShadowBoxingType;
};

@Injectable({
  providedIn: 'root'
})
export class ChallengeShadowBoxingService {

  constructor(private cvApiService: CVApiService) { }


  async giveAPunch(challengeId: number): Promise<ShadowBoxingType> {
    try {
      const url = '/api/v1/gamification/shadow-boxing/punch';
      const body = {
        challengeId
      };
      const response = await this.cvApiService.post<ShadowBoxingResponse>(url, body);
      if (response.status_code >= 200 && response.status_code < 300) {
        return { ...response.data.shadowBoxing, newPunch: true };
      } else {
        throw response;
      }
    } catch (error) {
      return null;
    }
  }

  isChallengeWon(shadowBoxing: ShadowBoxingType){
    const difficulty: DifficultKeys = DIFFICULTY[shadowBoxing.Difficulty];
    if (difficulty) {
      const hp = ShadowBoxingHP[difficulty];
      if (hp) {
        return shadowBoxing.Punch === hp;
      }
    }
    return false;
  }

}

export type ShadowBoxingType = {
  Difficulty: number;
  DailyGoalMetricValue: number;
  DailyGoalMetricString: string;
  MetricID: number;
  hasPunch: boolean;
  Punch: number;
  LastPunchRefreshDate?: Date;
  newPunch?: boolean;
  hiddeResults?: boolean;
};

type DifficultyHpRewards = {
  EASY: number,
  MEDIUM: number,
  HARD: number
};

export const GEMS: DifficultyHpRewards = {
  EASY: 1,
  MEDIUM: 2,
  HARD: 4
} as const;

export const ShadowBoxingHP: DifficultyHpRewards = {
  EASY: 2,
  MEDIUM: 3,
  HARD: 4
};

export const DIFFICULTY = {
  1: 'EASY',
  2: 'MEDIUM',
  3: 'HARD',
} as const;

export type DifficultKeys = keyof DifficultyHpRewards;

export type TChallenge = {
  ChallengeID?: number;
  Metrics?: string;
  EndDate_NoYear?: string;
  StartDate_NoYear?: string;
  MetricDefaultDirection?: number;
  ChallengeWasRemoved?: boolean;
  ChallengeType?: number;
  isNotFirstTimeModal?: boolean;
  Rankings?: {
    ViewScore: string;
    ActualScore: number;
    MetricValue?: number;
  }[];
  shadowBoxing?: ShadowBoxingType;
  ChallengeEnded?: boolean;
};

export type ChallengeStatusType = -1 | 0 | 1 | 2 | 3;
export const ChallengeStatusValues = {
  UNKNOW: -1,
  PENDING: 0,
  UPCOMING: 1,
  ACTIVE: 2, 
  ENDED: 3,
} as const;

export const HP_VALUES: number[] = [2, 3, 4];
